import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class FormatService {
  

    constructor(

    ) { }

    
    // stylizeNumber(n:string) {
    //     // return n.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        
    //     let digits = n.replace(/[^\d]/g, '').replace(/^0+(?!$)/, '');
    //     const base = digits || '0';        // if empty, treat as 0
    //     return base.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    // }


    // format number 1000000 to 1,234,567 (preserves decimals)
    stylizeNumber(n: string) {
      if (n == null) { return '0'; }
      const str = String(n);

      // If there's a decimal point
      if (str.indexOf('.') >= 0) {
        // Fractional-only inputs like ".25" should return just the fraction digits ("25")
        if (str[0] === '.') {
          return str.replace(/[^\d]/g, '');
        }

        const parts = str.split('.');
        const intPartRaw = parts.shift() || '';
        const fracRaw = parts.join(''); // join remaining parts in case of extra dots

        const intDigits = intPartRaw.replace(/[^\d]/g, '').replace(/^0+(?!$)/, '') || '0';
        const fracDigits = fracRaw.replace(/[^\d]/g, '');

        const intFormatted = intDigits.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

        return fracDigits ? intFormatted + '.' + fracDigits : intFormatted + '.';
      }

      // No decimal: behave as before
      let digits = str.replace(/[^\d]/g, '').replace(/^0+(?!$)/, '');
      const base = digits || '0';
      return base.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }


    number(event:any) {
        // get input value
        let input_val = event;
        if(event && event.target) input_val = event.target.value;
        
        // don't validate empty input
        if (input_val === "") { return; }

        if(Math.sign(Number(input_val)) === -1) {
            event.target.value = 0;
            return
        }

        // add commas to number and remove all non-digits
        input_val = this.stylizeNumber(input_val);
        
        // send updated string to input
        event.target.value = input_val;
    }

    /**
     * 
     * @param event string to format or input blur/keyup event
     * @param blur whether the function is called on blur or not
     * @returns the updated value
     */
    // appends $ to value, validates decimal side
    // and puts cursor back in right position.
    currency(event:any, blur: boolean = false) {
        // get input value
        let isString: boolean = true;
        let input_val = event;
        if(event && event.target) {
          input_val = event.target.value;
          isString = false;
        }
        
        // don't validate empty input
        if (input_val === "") { return; }
          
        // check for decimal
        if (input_val.indexOf(".") >= 0) {
      
          // get position of first decimal
          // this prevents multiple decimals from
          // being entered
          var decimal_pos = input_val.indexOf(".");
      
          // split number by decimal point
          var left_side = input_val.substring(0, decimal_pos);
          var right_side = input_val.substring(decimal_pos);
      
          // add commas to left side of number
          left_side = this.stylizeNumber(left_side);
      
          // validate right side
          right_side = this.stylizeNumber(right_side);
          
          // On blur make sure 2 numbers after decimal
          if (blur === true) {
            right_side += "00";
          }
          
          // Limit decimal to only 2 digits
          right_side = right_side.substring(0, 2);
      
          // join number by .
          input_val = "$" + left_side + "." + right_side;
      
        } 
        else {
          // no decimal entered
          // add commas to number
          // remove all non-digits
          input_val = this.stylizeNumber(input_val);
          input_val = "$" + input_val;
          
          // final formatting
          if (blur === true) {
            input_val += ".00";
          }
        }
        
        // return updated string or send to input
        if(isString) return input_val;
        else event.target.value = input_val;
    }
    
}
